import { useContext } from "react";
import styles from "./styles.module.css";
import ProductContext from "context/ProductContext";
import SearchContext from "context/SearchContext";
import SkeletonLoading from "../Loading/SkeletonLoading";

function CategoriesNavebar({ categories = [], isloading = false }) {
  const { selectedCategory, setSelectedCategory } = useContext(ProductContext);
  const { setSearchTerm } = useContext(SearchContext);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setSearchTerm("");
  };

  return (
    <div className={styles.container}>
      <nav className={styles.hScroll} aria-label="categories">
        <div className={styles.hList}>
          {isloading && <SkeletonLoading isOpen={isloading} height={40} xs={12} sm={12} md={12} lg={12} />}
          {categories.map((category) => {
            const isSelected = selectedCategory?.id === category?.id;
            const label = category?.name
              ? category.name.charAt(0).toUpperCase() + category.name.slice(1).toLowerCase()
              : "";

            return (
              <button
                key={category.id}
                className={`${styles.pill} ${isSelected ? styles.pillActive : ""}`}
                onClick={() => handleCategoryClick(category)}
                aria-pressed={isSelected}
              >
                <span className={styles.pillLabel}>{label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}

export default CategoriesNavebar;
